'use client';

import { useMemo } from 'react';

import { useSearchParams } from '@/hooks/use-search-params.hook';
import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';
import { buildPersistedParamsQueryString, appendPersistedParamsToUrl } from '@/utils/persisted-params.util';

export const usePersistedUserNavigationSearchParams = (link: string) => {
  const searchParams = useSearchParams(Object.values(PersistedUserNavigationSearchParams));

  return useMemo(() => {
    const persistedParamsValues = Object.values(PersistedUserNavigationSearchParams).reduce((acc, key) => {
      acc[key] = searchParams[key];
      return acc;
    }, {} as Record<string, string | null>);

    const queryString = buildPersistedParamsQueryString({
      searchParams: persistedParamsValues,
    });

    const [baseLink] = link.split('?');
    return appendPersistedParamsToUrl(baseLink, queryString);
  }, [link, searchParams]);
};
